import { InboxNotificationItem } from './inboxTypes';
import { getNotificationTypeLabel, getNotificationTypeClass, inboxText, formatInboxTimestamp } from './inboxUtils';

interface InboxListItemProps {
    notification: InboxNotificationItem;
    isSelected: boolean;
    isRead: boolean;
    onClick: () => void;
}

export const InboxListItem = ({ notification, isSelected, isRead, onClick }: InboxListItemProps) => {
    const typeLabel = getNotificationTypeLabel(notification.type);
    const typeClass = getNotificationTypeClass(notification.type);

    return (
        <div
            className={`inbox-list-item ${isSelected ? 'selected' : ''} ${!isRead ? 'unread' : ''}`}
            onClick={onClick}
        >
            <div className="inbox-list-item-header">
                <span className={`inbox-type-badge ${typeClass}`}>{typeLabel}</span>
                <span className="inbox-list-item-time">{inboxText(notification.relativeTime)}</span>
            </div>
            <h4 className="inbox-list-item-title">{inboxText(notification.title)}</h4>
            <p className="inbox-list-item-desc">{inboxText(notification.description)}</p>
            <span className="inbox-list-item-location">
                {[
                    inboxText(notification.unitName) || inboxText(notification.equipmentName),
                    inboxText(notification.locationName),
                    inboxText(notification.noticeOrigin),
                    formatInboxTimestamp(notification.timestamp),
                ].filter(Boolean).join(' · ')}
            </span>
        </div>
    );
};
